import { ProjectsSchema } from "@/entities/projects/model/types";
import { z } from "zod";

const ContactsSchema = z.object({
    schedule: z.string(),
    address: z.string(),
    phone: z.string(),
    telegramUrl: z.string().url(),
    whatsappUrl: z.string().url(),
    maxUrl: z.string().url(),
});

const DistrictSchema = z.object({
    id: z.number(),
    name: z.string(),
});

const StatusListSchema = z.record(z.string(), z.string())

const TierSchema = z.record(z.string(), z.string())

export const SiteDataSchema = z.object({
    id: z.string(),
    contacts: ContactsSchema,
    exclusiveSelectionLink: z.string(),
    roomOptions: z.array(z.number()),
    statusList: StatusListSchema,
    tiers: TierSchema,
    districts: z.array(DistrictSchema),
    prices: z.array(z.number().nonnegative()),
    projects: ProjectsSchema
});

export type SiteDataType = z.infer<typeof SiteDataSchema>; 
export type ContactsType = z.infer<typeof ContactsSchema>;
export type DistrictType = z.infer<typeof DistrictSchema>;
export type StatusListType = z.infer<typeof StatusListSchema>;
export type TiersType = z.infer<typeof TierSchema>;
